import React from 'react';
import { Container } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import BottomNavigation from '../../components/atoms/BottomNavigation';
import { TopNavigation } from '../../components/atoms/TopNavigation';

export default function Personal() {
  const navigate = useNavigate();

  return (
    <Container component="main">
      <TopNavigation type="back" handleEvent={() => navigate('/setting')}>
        개인정보취급방침
      </TopNavigation>

      <MenuListWrap>
        <PreStyled>
          {`  골펀 개인정보처리방침
  골펀 (이하 '회사'라 함)은 정보통신망 이용촉진 및 정보보호 등에 관한 법률, 「개인정보보호법」, 「통신비밀보호법」, 「전기통신사업법」 등 정보통신 서비스 제공자가 준수하여야 할 관련 법령상의 개인정보보호 규정을 준수하며, 관련 법령에 의거한 개인정보처리방침을 정하여 이용자 권익 보호에 최선을 다하고 있습니다. 회사는 본 개인정보처리방침을 게임 내 고객센터 및 홈페이지 첫 화면에 공개함으로써 회원이 용이하게 찾아볼 수 있도록 하고 있는바, 본 개인정보처리방침은 관계 법령 및 지침의 변경이나 회사의 내부 방침 변경 등으로 인하여 수시로 변경될 수 있으며, 회사가 개인정보처리방침을 개정하는 경우 변경 이유 및 내용에 대하여 고객센터나 홈페이지의 첫 화면 내지 연결화면을 통해 공지합니다.

  본 개인정보처리방침은 다음과 같은 내용을 담고 있습니다.

  1. 수집하는 개인정보의 항목 및 수집방법
  2. 개인정보의 수집 및 이용목적
  3. 개인정보 공유 및 제공
  4. 개인정보의 처리위탁
  5. 개인정보의 보유 및 이용기간
  6. 개인정보 파기절차 및 방법
  7. 이용자 및 법정대리인의 권리와 그 행사방법
  8. 개인정보 자동 수집장치의 설치/운영 및 거부에 관한 사항
  9. 개인정보의 기술적/관리적/물리적 보호대책
  10. 개인정보보호 책임자 및 담당자의 연락처
  11. 고지의 의무
  12. 기타

  1. 수집하는 개인정보의 항목 및 수집방법
  가. 수집하는 개인정보의 항목
  회원가입, 고객상담, 각종 서비스의 제공을 위해 다음과 같은 개인정보를 수집하고 있습니다.
  닉네임, 단말기 정보 (모델명, OS버전, 기기고유식별번호 등), 통신사 정보, 스토어정보, 게임버전, 게임 및 서비스 이용기록, 접속기록, 쿠키, 결제기록, 유료 과금정보, 프로모션/이벤트 참여기록 및 상품 발송 관련 정보, IP 주소
  외부 플랫폼 기반 서비스 이용 시 다음 정보가 수집될 수 있습니다.
  카카오톡: 회원식별자정보, 프로필 사진, 프로필 이름, 카카오 친구 목록
  페이스북: 회원식별자정보, 프로필 사진, 프로필 이름
  구글: 회원식별자정보, 프로필 사진, 프로필 이름
  일부 서비스에서 연령확인 혹은 관련법률에 따라 본인인증이 필요한 경우, 인증된 기관을 통해 본인확인값(CI)을 처리하고 있습니다.
  고객님의 문의사항처리와 프로모션 상품 발송을 위해 이메일주소, 이동전화번호 ,주소 정보를 처리 할 수 있습니다.
  제세공과금 처리를 위해 성명, 주민등록번호를 처리 할 수 있습니다.

  나. 개인정보 수집방법
  회사의 서비스 가입 시 동의 절차 제공을 통해 수집
  프로모션 및 이벤트 진행을 위해서는 별도의 동의절차를 통해 수집
  회사와 서비스 제공 관련 제휴관계에 있는 플랫폼을 통해 자동으로 수집
  서비스 가입 및 사용 중 고객응대 시 이용자의 자발적 제공 또는 필요에 의해 요청 후 수집
  다. 개인정보 수집∙이용의 거부
  이용자는 위 개인정보의 수집 및 이용을 거부할 수 있습니다. 다만, 개인정보의 수집 및 이용을 거부할 경우 서비스 일부 또는 전체의 이용이 어려울 수 있습니다.
  2. 개인정보의 수집 및 이용목적
  회사는 이용자의 사전동의 없이는 수집한 개인정보를 공개하지 않으며, 수집된 정보는 다음의 목적 이외의 용도로는 이용되지 않습니다.

  가. 서비스 제공에 관한 계약 이행 및 서비스 제공에 따른 요금정산
  콘텐츠 제공, 이벤트 당첨안내, 물품배송 또는 청구서 등 발송, 본인인증, 구매 및 요금 결제, 요금추심(단, 카카오 등 모바일 플랫폼을 통하여 회원가입 및 동의절차가 진행될 경우, 위 항목 중 일부는 위 모바일 플랫폼에서 수행하는 역할에 해당함)
  나. 회원보호
  회원제 서비스 이용에 따른 본인확인, 개인식별, 불량회원(이용약관 위반에 따라 이용제한 또는 계약 해지된 회원)의 부정 이용 방지와 비인가 사용방지, 가입의사 확인, 가입 및 가입횟수 제한, 분쟁 조정을 위한 기록보존, 불만처리 등 민원처리, 고지사항 전달
  다. 신규서비스 개발 및 마케팅, 광고에의 활용
  신규서비스 개발 및 맞춤서비스 제공, 인구통계학적 특성에 따른 서비스 제공 및 광고게재, 서비스의 유효성 확인, 이벤트 및 광고성 정보 제공 및 참여기회 제공, 접속빈도 파악, 회원이 서비스 이용에 대한 통계, 프로모션/이벤트 서비스 제공
  3. 개인정보 공유 및 제공
  회사는 이용자의 개인정보를 2. “개인정보 수집 및 이용목적”에서 고지한 범위 내에서 사용하며, 원칙적으로 이용자의 사전 동의 없이는 동 범위를 초과하여 이용하거나 이용자의 개인정보를 외부에 공개하지 않습니다. 다만, 아래의 경우에는 예외로 합니다.

  이용자가 사전에 공개 또는 제공에 동의한 경우
  「금용실명거래 및 비밀보장에 관한 법률」, 「신용정보의 이용 및 보호에 관한 법률」, 「전기통신기본법」, 「전기통신사업법」, 「지방세법」, 「소비자보호법」, 「한국은행법」, 「형사소송법」 등 법률에 특별한 규정이 있는 경우, 수사목적으로 법령에 정해진 절차와 방법에 따라 법원, 수사기관, 기타 행정기관의 요구가 있는 경우
  통계작성, 학술연구 또는 시장조사를 위하여 필요한 경우로서 다른 정보와 결합하여도 특정 개인을 알아볼 수 없는 형태로 가공하여 제공하는 경우
  4. 개인정보의 처리위탁
  회사는 전문적인 고객지원 및 서비스 향상을 위하여 아래와 같이 개인정보를 위탁하여 운영하고 있으며, 관계법령에 따라 위탁계약 시 개인정보가 안전하게 보호될 수 있도록 필요한 사항을 규정하고 있습니다. 회사의 개인정보 처리 위탁처리 기관 및 위탁업무 내용은 아래와 같습니다.

  [개인정보 위탁업체 자세히 보기]
  개인정보 처리위탁 중 국외에서 처리하는 위탁업무는 아래와 같습니다.

  [개인정보 국외이전 위탁업체 자세히 보기]
  5. 개인정보의 보유 및 이용기간
  “회사”는 「개인정보 보호법」 및 동법 시행령에 따라 연속하여 1년 동안 서비스를 이용하지 않은 회원(이하 '휴면계정'이라 함)의 개인정보를 보호하기 위해 계약을 해지하고 개인정보 파기 및 분리 보관 등 필요한 조치를 취할 수 있습니다. 이 경우, 조치일 30일 이전에 개인정보 보유기간 만료일 및 개인정보의 조치내용을 '회원'에게 통지합니다.

  이용자의 동의 하에 수집된 개인정보는 회원 자격이 유지되는 동안 보유 및 이용되며, 원칙적으로 개인정보의 수집 및 이용목적이 달성되면 해당 정보를 지체 없이 파기합니다. 단, 개인정보 도용 등으로 인한 원치 않는 회원탈퇴 등에 대비하기 위해 회원탈퇴 요청 후 7일 간 개인정보를 보유합니다.

  또한 다음의 정보에 대해서는 아래의 이유로 명시한 기간 동안 보존하며, 그 외 다른 목적으로는 절대 사용하지 않습니다.

  가. 회사 내부 방침에 의한 정보 보유 사유
  부정이용기록, 중복가입확인정보(DI)
  보존이유: 부정 이용 방지
  보존기간: 1년
  나. 관련법령에 의한 정보보유 사유
  계약 또는 청약철회 등에 관한 기록
  보존이유: 전자상거래 등에서의 소비자보호에 관한 법률
  보존기간: 5년
  대금결제 및 재화 등의 공급에 관한 기록
  보존이유: 전자상거래 등에서의 소비자보호에 관한 법률
  보존기간: 5년
  소비자의 불만 또는 분쟁처리에 관한 기록
  보존이유: 전자상거래 등에서의 소비자보호에 관한 법률
  보존기간: 3년
  본인확인에 관한 기록
  보존이유: 정보통신망 이용촉진 및 정보보호 등에 관한 법률
  보존기간: 6개월
  서비스 방문기록
  보존이유: 통신비밀보호법
  보존기간: 3개월
  다. 개별적으로 회원의 동의를 받은 경우
  6. 개인정보 파기절차 및 방법
  이용자의 개인정보는 원칙적으로 수집 및 이용목적이 달성되면 지체 없이 파기합니다. 회사의 개인정보 파기절차 및 방법은 다음과 같습니다.

  가. 파기절차
  이용자가 회원가입 등을 위해 입력한 정보는 목적이 달성된 후 별도의 DB로 옮겨져 (종이의 경우 별도의 서류함) 내부 방침 및 기타 관련 법령에 의한 정보보호 사유에 따라 일정기간 저장된 후 파기됩니다.
  동 개인정보는 법률에 의한 경우가 아니고서는 보유되는 이외의 다른 목적으로 이용되지 않습니다.
  나. 파기방법
  종이에 출력된 개인정보는 분쇄기로 분쇄하거나 소각을 통하여 파기합니다. 전자적 파일 형태로 저장된 개인정보는 기록을 재생할 수 없는 기술적 방법을 사용하여 삭제합니다.
  7. 이용자 및 법정대리인의 권리와 그 행사방법
  가. 이용자의 권리와 그 행사방법
  이용자는 언제든지 등록되어 있는 자신의 개인정보를 조회하거나 수정할 수 있으며, 회사의 개인정보의 처리에 동의하지 않는 경우 동의를 거부하거나 가입해지(게임탈퇴)를 요청하실 수 있습니다. 다만, 그러한 경우 서비스의 일부 또는 전부 이용이 어려울 수 있습니다. 이용자의 개인정보 조회 및 수정을 위해서는 ‘개인정보변경’(또는 ‘회원정보수정’ 등)을, 가입해지(동의철회)를 위해서는 '고객센터' 또는 “회원탈퇴”를 통하여 본인 확인 절차를 거치신 후 직접 열람, 정정 또는 탈퇴가 가능합니다. 또는 개인정보보호책임자에게 서면, 전화 또는 이메일로 연락하시면 지체 없이 조치하겠습니다. 이용자의 요청에 의해 해지 또는 삭제된 개인정보는 “회사”가 수집하는 제 5조의 “개인정보의 보유 및 이용기간”에 명시된 바에 따라 처리하고, 그 외의 용도로 열람 또는 이용할 수 없도록 처리하고 있습니다.
  나. 만 14세 미만 아동의 개인정보보호
  회사는 원칙적으로 이용자가 만 14세 미만일 경우 개인정보를 수집하지 않습니다.
  법정대리인이 14세 미만자의 '회사'의 서비스 탈퇴를 요청하는 경우, 탈퇴처리가 가능한 방법을 법정 대리인에게 안내 드립니다.
  부득이 이용자의 요청에 의한 업무를 처리하기 위해, 만 14세 미만의 개인정보를 수집이 필요할 때에는 사전에 법정대리인의 동의를 구하고 관련 업무가 종료되면 관련 정보를 지체 없이 파기합니다.
  8. 개인정보 자동 수집 장치의 설치/운영 및 거부에 관한 사항
  회사는 이용자들에게 맞춤서비스를 제공하기 위해서 이용자의 정보를 저장하고 수시로 불러오는 '쿠키(cookie)'를 사용합니다. 쿠키는 서비스를 운영하는데 이용되는 서버가 이용자의 PC 또는 모바일 기기에 보내는 아주 작은 텍스트 파일로 이용자의 PC 또는 모바일 기기에 저장되기도 합니다.
  회사는 쿠키를 이용하여 회원과 비회원의 방문 및 이용형태, 이용자의 규모 등을 파악하여 더 편리한 서비스를 만들고 제공하는데 사용됩니다. 이용자는 쿠키 설치에 대하여 선택권을 가지고 있습니다. 쿠키가 저장될 때마다 확인을 거치거나, 모든 쿠키의 저장을 거부할 수 있습니다. 다만, 쿠키의 저장을 거부할 경우에는 로그인이 필요한 서비스의 일부 또는 전부 이용이 어려울 수 있습니다.
  쿠키 설치 허용 여부를 지정하는 방법은 웹 브라우저 메뉴에서 “도구 > 인터넷옵션”에서 설정하실 수 있습니다.
  또한, '온라인 맞춤형 광고 개인정보보호 가이드 라인'에 따른 이용자 권리보호를 위한 페이지도 제공하고 있습니다.
  [카카오게임즈 맞춤형광고 안내]

  9. 개인정보의 기술적/관리적/물리적 보호대책
  회사는 이용자들의 개인정보를 처리함에 있어 개인정보가 분실, 도난, 유출, 변조 또는 훼손되지 않도록 안전성 확보를 위하여 다음과 같은 대책을 강구하고 있습니다.

  가. 해킹 등에 대비한 대책
  회사”는 해킹이나 컴퓨터 바이러스 등에 의해 회원의 개인정보가 유출되거나 훼손되는 것을 막기 위해 최선을 다하고 있습니다. 개인정보의 훼손에 대비해서 자료를 수시로 백업하고 있으며, 최신 백신 프로그램을 이용하여 이용자들의 개인정보나 자료가 유출되거나 손상되지 않도록 방지하고 있고, 암호화통신으로 네트워크상에서 개인정보를 안전하게 전송할 수 있도록 하고 있습니다. 그리고 침입차단시스템을 이용하여 외부로부터의 무단 접근을 통제하고 있으며, 기타 시스템적으로 보안성을 확보하기 위한 가능한 모든 기술적 장치를 갖추려 노력하고 있습니다. 단, 이용자 본인의 부주의나 인터넷상의 문제로 ID, 비밀번호, 생년월일 등 개인정보가 유출되어 발생한 문제에 대해 회사는 일체의 책임을 지지 않습니다.
  나. 처리대상자의 최소화 및 교육
  회사”는 이용자의 개인정보에 대한 접근 대상자를 최소한의 인원(개인정보를 처리할 수 있는 담당자)으로 한정시키고 있고 이를 위한 별도의 비밀번호를 부여하여 정기적으로 갱신하고 있으며, 담당자에 대한 수시 교육을 통하여 회사 개인정보처리방침의 준수를 항상 강조하고 있습니다.
  다. 개인정보보호전담기구의 운영
  회사”는 사내 개인정보보호전담기구 등을 통하여 회사 개인정보처리방침의 이행사항 및 담당자의 준수여부를 확인하여 문제가 발견될 경우 즉시 수정하고 바로잡을 수 있도록 노력하고 있습니다. 단, 이용자 본인의 부주의나 인터넷상의 문제로 아이디, 비밀번호, 주민등록번호 등 개인정보가 유출되어 발생한 문제에 대해 회사는 일체의 책임을 지지 않습니다.
  라. 출입 및 보관 통제
  회사”는 개인정보를 처리 및 보관하는 지역은 보안구역으로 정의하고 비인가자나 외부인의 출입을 통제하고 있으며, 개인정보를 포함하는 인쇄물, 출력물 수기 기록 및 외장형 저장 매체 등은 잠금 장치가 있는 안전한 장소에 보관해 잠금 장치를 해제하지 않고서는 그 내용이나 해당 정보의 유무 확인이 불가 하도록 보호하고 있습니다.
  10. 개인정보보호 책임자 및 담당자의 연락처
  회사는 이용자들의 개인정보를 보호하고 개인정보와 관련된 불만을 처리하기 위하여 아래와 같이 담당 부서 및 개인정보 보호책임자를 지정하고 있습니다. 회사의 서비스를 이용하시며 발생하는 모든 개인정보보호 관련 민원을 개인정보보호책임자 혹은 담당부서로 신고하실 수 있습니다. 회사는 이용자들의 신고사항에 대해 신속하게 답변을 드릴 것입니다.

  개인정보 보호책임자
  이름 : 김경준
  소속/직위: 개발팀/팀장
  이메일: golfun@greendata.kr
  전화번호 :

  개인정보 보호담당자
  이름: 정동욱
  소속/직위: 개발팀/개발자
  이메일: golfun@greendata.kr
  전화번호 :

  기타 개인정보침해에 대한 신고나 상담이 필요하신 경우에는 아래 기관에 문의하시기 바랍니다.

  전자거래분쟁조정위원회 (http://www.ecmc.or.kr / 1661-5714)
  개인정보침해신고센터 (http://privacy.kisa.or.kr / 국번없이 118)
  대검찰청 사이버범죄수사단 (www.spo.go.kr / 국번없이 1301)
  경찰청 사이버안전국 (http://cyberbureau.police.go.kr / 국번 없이 182)

  11. 고지의 의무
  회사는 개인정보 처리방침의 내용 추가, 삭제 및 수정이 있을 시에는 개정 최소 7일 전부터 서비스 초기화면 등을 통해 고지할 것입니다.

  12. 기타
  회사가 제공하는 서비스에 링크되어 있는 다른 회사의 웹사이트에서 개인정보를 수집하는 행위에 대해서는 본 개인정보처리방침이 적용되지 않습니다. 이용자가 새로 방문하는 웹사이트에서의 개인정보 수집과 관련한 사항은 해당 사이트의 개인정보처리방침을 확인하시기 바랍니다.

  부칙
  공고일자: 2023년 9월 22일
  시행일자: 2023년 9월 29일`}
        </PreStyled>
      </MenuListWrap>
      <BottomNavigation loc="mypage" />
    </Container>
  );
}

const MenuListWrap = styled.div`
  width: 100%;
`;

const PreStyled = styled.pre`
  white-space: pre-line;
  font-family: initial;
  text-wrap: unset;
`;
